document.addEventListener('turbo:load', function () {
    if (document.getElementById('community-feed-items')) {
        const baseFeedItemsPath = document.getElementById('community-feed-items').dataset.basePath;
        const recommendedSrc = `${baseFeedItemsPath}&filter=recommended`;
        const followingSrc = `${baseFeedItemsPath}&filter=following`;

        const communityFeedItems = document.getElementById('community-feed-items');
        const recommendedButton = document.querySelector("button[data-option='recommended']");
        const followingButton = document.querySelector("button[data-option='following']");
        const indicator = document.querySelector(".indicator");
        const feedItemContainer = document.querySelector(".feed-item-container");
        const feedItemsRecommended = document.getElementById("feed_items_recommended");
        const feedItemsFollowing = document.getElementById("feed_items_following");

        function updateSrcIfNeeded(option) {
            if (option === 'recommended' && !feedItemsRecommended.getAttribute('src')) {
                feedItemsRecommended.setAttribute('src', recommendedSrc);
            } else if (option === 'following' && !feedItemsFollowing.getAttribute('src')) {
                feedItemsFollowing.setAttribute('src', followingSrc);
            }
        }

        function saveScrollPosition() {
            // Get current active tab
            const activeTab = communityFeedItems.dataset.activeTab || 'recommended';
            // Store scroll position for the specific tab
            communityFeedItems.dataset[`scrollY_${activeTab}`] = window.scrollY;
        }

        function restoreScrollPosition(option) {
            // Restore scroll position for the specific tab
            const tabToRestore = option || communityFeedItems.dataset.activeTab || 'recommended';
            const savedPosition = parseInt(communityFeedItems.dataset[`scrollY_${tabToRestore}`] || '0');
            window.scrollTo(0, savedPosition);
        }

        function toggleClasses(option) {
            const isRecommended = option === 'recommended';
            
            // Update text colors for active/inactive states
            recommendedButton.classList.toggle("text-warm-gray-900", isRecommended);
            recommendedButton.classList.toggle("text-warm-gray-600", !isRecommended);
            followingButton.classList.toggle("text-warm-gray-900", !isRecommended);
            followingButton.classList.toggle("text-warm-gray-600", isRecommended);
            
            // Update indicator position
            indicator.classList.toggle("translate-x-[calc(100%+0.25rem)]", !isRecommended);
            indicator.classList.toggle("translate-x-0", isRecommended);
            
            // Update feed container position
            feedItemContainer.classList.toggle("-translate-x-full", !isRecommended);
            feedItemContainer.classList.toggle("translate-x-0", isRecommended);
        }

        function setActiveTab(option) {
            // Save scroll position of current tab before switching
            saveScrollPosition();

            // Update the active tab
            toggleClasses(option);
            updateSrcIfNeeded(option);
            communityFeedItems.dataset.activeTab = option;
            localStorage.setItem('communityFeedTab', option);

            // Restore scroll position for the new tab
            setTimeout(() => {
                restoreScrollPosition(option);
            }, 50);
        }

        recommendedButton.addEventListener('click', () => setActiveTab('recommended'));
        followingButton.addEventListener('click', () => setActiveTab('following'));

        // Save scroll position when scrolling
        window.addEventListener('scroll', saveScrollPosition);

        // Save scroll position before navigating away
        document.addEventListener('turbo:before-visit', saveScrollPosition);

        // Set active tab based on localStorage or default to recommended
        // Disable transitions for initial load to prevent animation flash
        const savedTab = localStorage.getItem('communityFeedTab') || 'recommended';
        indicator.style.transition = 'none';
        feedItemContainer.style.transition = 'none';
        setActiveTab(savedTab);
        // Force reflow, then re-enable transitions
        indicator.offsetHeight;
        indicator.style.transition = '';
        feedItemContainer.style.transition = '';

        // Try to restore scroll position after content loads
        document.addEventListener('turbo:frame-load', function (event) {
            // Only restore if the loaded frame is one of our feed frames
            if (event.target.id === 'feed_items_recommended' || event.target.id === 'feed_items_following') {
                // Use setTimeout to ensure content has rendered
                setTimeout(() => {
                    restoreScrollPosition();
                }, 100);
            }
        });

        // Also try to restore on full page load
        window.addEventListener('load', function () {
            setTimeout(() => {
                restoreScrollPosition();
            }, 100);
        });

        // Initial attempt to restore scroll
        setTimeout(() => {
            restoreScrollPosition();
        }, 0);
    }
});